import React, { useCallback, useState } from 'react'
import PropTypes from 'prop-types'
import ActionsMenu from '../../ui/ActionsMenu'
import DownloadIcon from '../../ui/icons/DownloadIcon'
import useIssueExport from '../hooks/useIssueExport'

const TRIGGER_BTN_CLASS = 'tw:inline-flex tw:items-center tw:justify-center '
  + 'tw:w-10 tw:h-10 tw:bg-white tw:border tw:border-solid tw:border-gray-300 '
  + 'tw:rounded! tw:text-gray-700 tw:hover:bg-gray-50 tw:cursor-pointer'

const EMPTY_SELECTION = new Set()

const ExportMenu = ({
  buildExportUrl, toastContainerId, selectedIds = EMPTY_SELECTION
}) => {
  const [anchorEl, setAnchorEl] = useState(null)
  const { exportTo, exporting } = useIssueExport(toastContainerId)

  const handleToggle = useCallback(event => {
    const target = event.currentTarget
    setAnchorEl(current => current ? null : target)
  }, [])
  const handleClose = useCallback(() => setAnchorEl(null), [])

  const handleExport = useCallback(format => {
    handleClose()
    exportTo(buildExportUrl(format, selectedIds))
  }, [exportTo, handleClose, buildExportUrl, selectedIds])

  const items = [
    { label: 'Exporter en Excel', icon: DownloadIcon, onClick: () => handleExport('xlsx') },
    { label: 'Exporter en PDF', icon: DownloadIcon, onClick: () => handleExport('pdf') }
  ]

  return (
    <>
      <button
        aria-label="Exporter les alertes"
        className={TRIGGER_BTN_CLASS}
        disabled={exporting}
        type="button"
        onClick={handleToggle}
      >
        <DownloadIcon className="tw:w-3 tw:h-3" />
      </button>
      <ActionsMenu
        anchorEl={anchorEl}
        ariaLabel="Options d’export"
        isOpen={Boolean(anchorEl)}
        items={items}
        onClose={handleClose}
      />
    </>
  )
}

ExportMenu.propTypes = {
  buildExportUrl: PropTypes.func.isRequired,
  selectedIds: PropTypes.instanceOf(Set),
  toastContainerId: PropTypes.string.isRequired
}

ExportMenu.defaultProps = {
  selectedIds: EMPTY_SELECTION
}

export default ExportMenu
